"use client";
import Image from "next/image";
import "./AIHeroSection.scss";
import robotImg from "@/assets/images/services/ai-implementation/banner/robot_img.webp";

import Robot from "@/assets/icons/services/ai/hero/robot.svg";
import Report from "@/assets/icons/services/ai/hero/report.svg";
import Analytic from "@/assets/icons/services/ai/hero/analytic.svg";
import Workflow from "@/assets/icons/services/ai/hero/workflow.svg";
import Chatbot from "@/assets/icons/services/ai/hero/chatbot.svg";

import { Col, Container, Row } from "react-bootstrap";
import CTAButton from "@/components/CTAButton/CTAButtons";

const FLOATING_TAGS = [
  { id: 1, icon: Robot, label: "AI Assistants", bottom: "90%", right: "50%" },
  { id: 2, icon: Report, label: "Smart Reporting", top: "20%", left: "80%" },
  {
    id: 3,
    icon: Analytic,
    label: "Predictive Analytics",
    top: "70%",
    right: "70%",
  },
  {
    id: 4,
    icon: Workflow,
    label: "Workflow Automation",
    top: "80%",
    left: "80%",
  },
  { id: 5, icon: Chatbot, label: "AI Chatbot", top: "100%", left: "30%" },
];

const AIHeroSection = ({ hero }) => {
  if (!hero) return null;

  const { title, description } = hero;
  return (
    <section className="ai-hero-section">
      <Container className="ai-hero-container">
        <Row className="align-items-center">
          <Col xxl={6} xl={6} lg={6}>
            <div className="hero-left-content">
              <h1>{title}</h1>
              <p>{description}</p>

              {/* CTA */}
              <CTAButton
                primaryText="Get Started Free"
                secondaryText="Watch a Demo"
              />
            </div>
          </Col>

          <Col xxl={6} xl={6} lg={6}>
            <div className="hero-right">
              <div className="animation-wrapper">
                {/* Animated concentric rings */}
                <div className="ring ring-1"></div>
                <div className="ring ring-2"></div>
                <div className="ring ring-3"></div>
                <div className="ring ring-4"></div>

                {/* Floating feature tags */}
                {FLOATING_TAGS.map((tag) => (
                  <div
                    key={tag.id}
                    className="floating-tag"
                    style={{
                      top: tag.top,
                      bottom: tag.bottom,
                      left: tag.left,
                      right: tag.right,
                      animationDelay: `${tag.id * 0.4}s`,
                    }}
                  >
                    <div className="tag-dot">
                      <Image
                        src={tag.icon}
                        alt={tag.label}
                        width={18}
                        height={18}
                      />
                    </div>
                    <span>{tag.label}</span>
                  </div>
                ))}

                <div className="robot-img-wrapper">
                  <Image
                    src={robotImg}
                    alt="robot-img"
                    className="robot-img"
                    width={420}
                    height={420}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AIHeroSection;
